// extracted by mini-css-extract-plugin
export default {"parent":"styles_parent__Y5J37","block":"styles_block__RzeCR","block_number":"styles_block_number__NzlbG","title":"styles_title__gAZy9"};